import { service } from '@maia/team';
import { queryOptions, QueryOptions } from '@tanstack/react-query';

export type Teams = Awaited<ReturnType<(typeof service)['findMany']>>;

export function getTeamsOptions(
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Teams>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['Teams'],
    queryFn: async () => await service.findMany(search),
    initialData,
  });
}
